import APIModel from "../APIModel";

export default class Docusign extends APIModel {
  constructor() {
    super();
  }

  async getSigningLink(): Promise<any> {
    return await this.http.ignoreErrorHandler().post(`/docusign/link`, {});
  }
  async getStatus(): Promise<any> {
    return await this.http.ignoreErrorHandler().post(`/docusign/status`, {});
  }
}
